import { DtoCoVendedor } from './../../../covendedor/dominio/DtoCoVendedor';
import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { SelectItem, LazyLoadEvent } from 'primeng/primeng';
import { PrincipalBaseComponent } from 'src/app/util/PrincipalBaseComponent';
import { NoAuthorizationInterceptor } from 'src/app/util/interceptor/NoAuthorizationInterceptor';
import { Router, ActivatedRoute } from '@angular/router';
import { FiltroGenerarPedido } from '../../dominio/FiltroGenerarPedido';
import { PersonamastSelectorComponent } from 'src/app/erp/core/personamast/vista/selector/personamastselector.component';
import { CoCotizacionServicio } from '../../servicio/cotizacion.service';
import { DtoCotizacionGenerarPedido } from '../../dominio/DtoCotizacionGenerarPedido';
import { CoVendedorServicio } from '../../../covendedor/servicio/covendedor.service';
import { DtoPersonamast } from 'src/app/erp/core/personamast/dominio/DtoPersonamast';
import { CoDocumentoServicio } from '../../../codocumento/service/codocumento.service';
import { DtoCotizacion } from '../../dominio/DtoCotizacion';
import { PersonamastServicio } from '../../../../core/personamast/service/personamast.service';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';

@Component({
    templateUrl: './generarpedido-listado.component.html'
})
export class GenerarPedidoListadoComponent extends PrincipalBaseComponent implements OnInit {
    PG_LISTADO: number = 0;
    PG_CLIENTE_SELECTOR: number = 3;
    PG_ACTUAL: number = 0;
    @ViewChild(Table,{static:false}) dataTableComponent: Table;
    @ViewChild(PersonamastSelectorComponent,{static:false}) personamastSelectorComponent: PersonamastSelectorComponent;

    listado: any[] = [[], []];
    lstVendedor: SelectItem[] = [];
    cargando: boolean = true;
    vende = new DtoCoVendedor;
    seleccionados: DtoCotizacionGenerarPedido[] = [];
    vendedorValidar: number;
    filtro: FiltroGenerarPedido = new FiltroGenerarPedido();
    filtrofechas: Boolean = true;
    sumatoriaSoles: number = 0;
    sumatoriaDolares: number = 0;
    generar: string;
    lstClientes: any[];
    dtoPersonamast: DtoPersonamast = new DtoPersonamast();

    constructor(
        private coDocumentoServicio: CoDocumentoServicio,
        private coVendedorServicio: CoVendedorServicio,
        private coCotizacionServicio: CoCotizacionServicio,
        private router: Router,
        private personamastServicio: PersonamastServicio,
        private route: ActivatedRoute,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService) { super(noAuthorizationInterceptor, messageService); }

    filterClienteSingle(event) {
        let query = event.query;
        this.personamastServicio.listarClientes(query).then(
            res => {
                this.lstClientes = res;
            }
        );
    }
    captureId(event: any) {
        this.dtoPersonamast.persona = event.persona;
    }

    ngOnInit() {
        this.bloquearPagina();
        this.generar = this.route.snapshot.params['generar'] as string;
        if (this.generar !== undefined) {
            const bean = JSON.parse(this.route.snapshot.params['bean']) as DtoCotizacion;
            this.dtoPersonamast.persona = bean.clienteNum;
            this.dtoPersonamast.busqueda = bean.clienteNombre;
            this.filtro.cotizacion = bean.numeroDocumento;
            this.buscar();
        }

        this.filtro.fechaInicio = new Date();
        this.filtro.fechaFin = new Date();
        this.lstVendedor.push({ label: 'TODOS VENDEDORES', value: null });
        this.coVendedorServicio.listarActivosDto().then(
            vendedores => {
                vendedores.forEach(
                    vendedor => {
                        this.lstVendedor.push({ label: vendedor.vendedorNombre, value: vendedor.vendedor });
                    }
                );
                this.desbloquearPagina();
            }
        );
    }

    toggleVisibility(e) {
        if (e) {
            this.filtro.fechaInicio = new Date();
            this.filtro.fechaFin = new Date();
        } else {
            this.filtro.fechaInicio = null;
            this.filtro.fechaFin = null;
        }
    }

    defaultBuscar(event?: any) {
        if (event.keyCode === 13) {
            this.buscar();
        }
    }

    onRowSelectSoles(event) {
        this.sumatoriaSoles = 0;
        this.seleccionados.forEach(item => {
            if (item.monedaDocumento === 'LO') {
                this.sumatoriaSoles = this.sumatoriaSoles + item.monto;
            }
        });
    }

    onRowSelectDolares(event) {
        this.sumatoriaDolares = 0;
        this.seleccionados.forEach(item => {
            if (item.monedaDocumento === 'EX') {
                this.sumatoriaDolares = this.sumatoriaDolares + item.monto;
            }
        });
    }

    eventCabeceraSoles(event) {
        this.sumatoriaSoles = 0;
        this.seleccionados.forEach(item => {
            if (item.monedaDocumento === 'LO') {
                this.sumatoriaSoles = this.sumatoriaSoles + item.monto;
            }
        });
    }

    eventCabeceraDolares(event) {
        this.sumatoriaDolares = 0;
        this.seleccionados.forEach(item => {
            if (item.monedaDocumento === 'EX') {
                this.sumatoriaDolares = this.sumatoriaDolares + item.monto;
            }
        });
    }

    buscar() {
        this.listado = [[], []];
        const listaLocal = [];
        const listaDolar = [];
        if (this.filtrofechas === false) {
            if (this.estaVacio(this.dtoPersonamast.persona) && this.estaVacio(this.filtro.cotizacion)) {
                this.mostrarMensajeAdvertencia('Debe Seleccionar un cliente o introducir un número de cotización');
                return;
            } else if (this.dtoPersonamast.persona === undefined && this.filtro.cotizacion === undefined) {
                this.mostrarMensajeAdvertencia('Debe Seleccionar un cliente o introducir un número de cotización');
                return;
            }
        }

        if (this.filtrofechas === false) {
            this.filtro.fechaInicio = null;
            this.filtro.fechaFin = null;

            if (this.filtro.fechaInicio != null && this.filtro.fechaFin != null) {
                if (this.filtro.fechaInicio > this.filtro.fechaFin) {
                    this.mostrarMensajeAdvertencia('La fecha de Fin debe se mayor o igual que la fecha de Inicio');
                    this.desbloquearPagina();
                    return;
                }
            }
        }

        this.bloquearPagina();
        this.filtro.cliente = this.dtoPersonamast.persona;

        this.coCotizacionServicio.listarCotizacionesGenerarPedido(this.filtro).then(
            x => {
                x.forEach(
                    g => {
                        if (g.monedaDocumento === 'LO') {
                            listaLocal.push(g);
                            if ('S' === this.generar) {
                                this.seleccionados.push(g)
                                this.sumatoriaSoles = 0;
                                this.seleccionados.forEach(item => {
                                    if (item.monedaDocumento === 'LO') {
                                        this.sumatoriaSoles = this.sumatoriaSoles + item.monto;
                                    }
                                });
                            }
                        } else {
                            listaDolar.push(g);
                            if ('S' === this.generar) {
                                this.seleccionados.push(g)
                                this.sumatoriaDolares = 0;
                                this.seleccionados.forEach(item => {
                                    if (item.monedaDocumento === 'EX') {
                                        this.sumatoriaDolares = this.sumatoriaDolares + item.monto;
                                    }
                                });
                            }
                        }
                    }
                );

                if (this.filtrofechas === false) {
                    this.filtro.fechaFin = null;
                    this.filtro.fechaInicio = null;
                }

                this.listado[1] = listaLocal;
                this.listado[0] = listaDolar;
                this.desbloquearPagina();
            }
        );
    }

    generarPedido() {

        if (this.seleccionados.length === 0) {
            this.mostrarMensajeAdvertencia('Seleccione un registro');
            return;
        }

        const monedaPrueba = this.seleccionados[0].monedaDocumento;
        const tipoDetallePrueba = this.seleccionados[0].tipoDetalle;

        let igualMoneda = true;
        let igualTipo = true;
        let vendedorN = 0;

        this.seleccionados.forEach(
            x => {
                vendedorN = x.vendedor;
                if (x.monedaDocumento !== monedaPrueba) {
                    igualMoneda = false;
                }
                if (x.tipoDetalle !== tipoDetallePrueba) {
                    igualTipo = false;
                }

                vendedorN = x.vendedor;
            }
        );

        this.vende.vendedor = vendedorN;
        this.coVendedorServicio.buscarIna(this.vende).then(
            x => {
                if (x > 0) {
                    this.mostrarMensajeAdvertencia('El vendedor se encuentra inactivo');
                    return;
                }
            }

        );

        if (!igualMoneda || !igualTipo) {
            this.mostrarMensajeAdvertencia('Solo se deben seleccionar cotizaciones del mismo Cliente, moneda y tipo de detalle (Items o Servicios).');
            return;
        }


        this.bloquearPagina();

        this.coDocumentoServicio.generarPedido(this.seleccionados).then(
            x => {
                this.desbloquearPagina();
                if (x != null) {
                    this.router.navigate(['/royal/pedido-mantenimiento', 'AUTO', JSON.stringify(x)], { skipLocationChange: true });
                }
            }
        ).catch(error => {
            this.mostrarMensajeAdvertencia(error);
            this.desbloquearPagina();
        });
    }

    limpiarCliente() {
        this.dtoPersonamast = new DtoPersonamast()
    }

    cancelarAccionSelector() {
        this.cargando = true;
        this.PG_ACTUAL = this.PG_LISTADO;
    }
}
